import { Outlet } from 'react-router-dom'
import useMe from '@/hooks/useMe'
import NotFound from '@/components/ui/NotFound'

/**
 * Garde de route : `roles` filtre sur le rôle. Le refus qui fait autorité est
 * côté serveur — ceci évite d'afficher une page vide à qui n'y a pas droit.
 */
export default function RoleGuard({ roles }) {
    const { role, isLoading } = useMe()

    if (isLoading) return null

    if (roles && !roles.includes(role)) {
        return <NotFound />
    }

    return <Outlet />
}
